import request from '@/utils/request'

// 查询配色物料关系列表
export function apiMaterialMatchColorRelationList (query) {
  return request({
    url: '/mdm/materialMatchColorRelation/list',
    method: 'get',
    params: query
  })
}

// 导出待配色关系列表V2
export function apiMaterialMatchColorRelationExport (data) {
  return request({
    url: '/mdm/materialMatchColorRelation/v2/export',
    method: 'post',
    data: data
  })
}

// 修改
export function apiMaterialMatchColorRelationEdit (data) {
  return request({
    url: '/mdm/materialMatchColorRelation',
    method: 'put',
    data: data
  })
}

// 刷新
export function apiRefreshMaterialColorRelation (query) {
  return request({
    url: '/mdm/refreshMaterialColorRelation',
    method: 'get',
    params: query
  })
}
